import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { HeaderComponent } from './header.component';
import { NavigationComponent } from './components/navigation/navigation.component';
import {LogoComponent} from "./components/logo/logo.component";
import { UserComponent } from './components/user/user.component';
import { ClickOutsideModule } from 'ng-click-outside';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ClickOutsideModule,
    TranslateModule,
  ],
  declarations: [
    HeaderComponent,
    NavigationComponent,
    LogoComponent,
    UserComponent,
  ],
  exports: [
    HeaderComponent,
  ],
})
export class HeaderModule {
}



// WEBPACK FOOTER //
// /codebuild/output/src1521087412/src/client/web-client/src/app/theme/header/header.module.ts